<div class="modal-header">
    <div>
        <h2>{{title}}</h2>
    </div>
    <div class="header-close-icon">
        <mat-icon (click)="closeModal()">close</mat-icon>
    </div>
</div>
<mat-divider></mat-divider>